module.exports = __webpack_public_path__ + "static/img/DST.e71de69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/DST.png
// module id = GlUl
// module chunks = 34